
// PARSE MENU FILE  
export const PARSE_MENU_SAGA = "PARSE_MENU_SAGA";
export const PARSE_MENU_FETCH = "PARSE_MENU_FETCH";
export const PARSE_MENU_SUCCESS = "PARSE_MENU_SUCCESS";
export const PARSE_MENU_ERROR = "PARSE_MENU_ERROR";

// UPLOAD MENU 
export const UPLOAD_MENU_SAGA = "UPLOAD_MENU_SAGA";
export const UPLOAD_EXPRESS_MENU_SAGA = "UPLOAD_EXPRESS_MENU_SAGA";
export const UPLOAD_MENU_SUCCESS = "UPLOAD_MENU_SUCCESS";

// MATCH MENU PAGE
export const GET_MATCH_MENU_SECTIONS_SAGA = "GET_MATCH_MENU_SECTIONS_SAGA";
export const GET_MATCH_MENU_SECTIONS_SUCCESS = "GET_MATCH_MENU_SECTIONS_SUCCESS";

export const GET_MATCH_MENU_PRODUCTS_SAGA = "GET_MATCH_MENU_PRODUCTS_SAGA";
export const GET_MATCH_MENU_PRODUCTS_SUCCESS = "GET_MATCH_MENU_PRODUCTS_SUCCESS";



export const IS_MATCHED_ALL_SAGA = "IS_MATCHED_ALL_SAGA";
export const IS_MATCHED_ALL_SUCCESS = "IS_MATCHED_ALL_SUCCESS";

export const CLEAR_MATCH_MENU_ITEMS = "CLEAR_MATCH_MENU_ITEMS";



